import { cn } from '@/legacy-src/lib/utils'

import { Heading } from '@/src/domains/design-system/components/Heading'
import {
  HeaderSubNavigationLink,
  type HeaderSubNavigationLinkProps,
} from '@/src/domains/header/components/Header/HeaderSubNavigationLink'

export interface HeaderSubNavigationProps {
  type?: HeaderSubNavigationLinkProps['type']
  iconColor?: HeaderSubNavigationLinkProps['iconColor']
  title?: string
  items: Omit<HeaderSubNavigationLinkProps, 'type' | 'iconColor'>[]
}

export const HeaderSubNavigation = ({ items, type, iconColor, title }: HeaderSubNavigationProps) => (
  <div
    className={cn('flex flex-1 flex-col gap-8 laptop:mt-8', {
      'gap-5 rounded-2xl bg-blue-500 p-5 laptop:mt-0 laptop:rounded-[2rem] laptop:p-8': type === 'tags',
    })}
  >
    {title ? (
      <Heading variant="xl" element="span" className="hidden text-secondary laptop:block">
        {title}
      </Heading>
    ) : null}
    <ul
      className={cn('list-enlarge-y-1.5 m-0 flex flex-col gap-2 p-0 laptop:gap-5', {
        'flex-row flex-wrap gap-4 laptop:gap-3': type === 'tags',
      })}
    >
      {items.map(({ id, href, title, target }) => (
        <li key={id ?? `${href}-${title}`} className="list-none">
          <HeaderSubNavigationLink href={href} type={type} target={target} iconColor={iconColor}>
            {title}
          </HeaderSubNavigationLink>
        </li>
      ))}
    </ul>
  </div>
)
